import {
  IS_OPEN_LOGIN_FORM,
  SELECTED_PLAN,
  PAYMENT_CHECKOUT_PAGE,
  FAVORATE_SONG,
  PODCAST_CLICK,
  IS_SUBSCRIPTION_CANCEL,
  SET_TRACK,
  SET_PLAYING,
  USER_SUBSCRIPTION,
  USER_SUBSCRIPTION_LOADING,
  SUBSCRIPTION_CTA
} from "./actions";

function loginReducer(state = false, action) {
  switch (action.type) {
    case IS_OPEN_LOGIN_FORM:
      return action.payload;
    default:
      return state;
  }
}

function selectedPlan(state = {}, action) {
  switch (action.type) {
    case SELECTED_PLAN:
      return action;
    default:
      return state;
  }
}

function paymentCheckout(state = {}, action) {
  switch (action.type) {
    case PAYMENT_CHECKOUT_PAGE:
      return action.payload;
    default:
      return state;
  }
}

function favorateSongPlaylist(state = {}, action) {
  switch (action.type) {
    case FAVORATE_SONG:
      return action.payload;
    default:
      return state;
  }
}

function hasSubscripton(state = {}, action) {
  switch (action.type) {
    case PODCAST_CLICK:
      return action.payload;
    default:
      return state;
  }
}

const initialPlayerState = {
  track: null,
  playing: false
};

function player(state = initialPlayerState, action) {
  switch (action.type) {
    case SET_TRACK:
      return { ...state, track: { ...action.payload.track } };
    case SET_PLAYING:
      return { ...state, playing: action.payload.playing, track: action.payload.track };
    default:
      return state;
  }
}

function amazonPollyReducer(state = { isOpen: false, storyData: {} }, action) {
  switch (action.type) {
    case "OPEN_AMAZON_POLLY":
      return { ...state, isOpen: true };
    case "CLOSE_AMAZON_POLLY":
      return { ...state, isOpen: false };
    case "UPDATE_AMAZON_POLLY_DATA":
      return { ...state, storyData: { ...action.payload.storyData } };
    default:
      return state;
  }
}

function isSubscriptionCancel(state = {}, action) {
  switch (action.type) {
    case IS_SUBSCRIPTION_CANCEL:
      return action.payload;
    default:
      return state;
  }
}

function isSubscribedUser(state = {}, action) {
  switch (action.type) {
    case USER_SUBSCRIPTION:
      return { ...state, ...action.payload };
    case USER_SUBSCRIPTION_LOADING:
      return { ...state, loading: true };
    default:
      return state;
  }
}

function showSubscriptionCTA(state = {}, action) {
  switch (action.type) {
    case SUBSCRIPTION_CTA:
      return action.payload;
    default:
      return state;
  }
}

export const REDUCERS = {
  isLoginOpen: loginReducer,
  selectedPlan,
  paymentCheckout,
  favorateSongPlaylist,
  hasSubscripton,
  amazonPolly: amazonPollyReducer,
  isSubscriptionCancel,
  player,
  isSubscribedUser,
  showSubscriptionCTA
};
